<template>
	<div>
		<div style="margin-top: 20px">
			<flCabecalhoForm
				:msg="_traducao('global', 'obrigatorio')"
				cls="print-titulo-form-20"
				:texto="_traducao('menuAGnovoUsuario', 'menuAGdadosCadastrais')"
			/>

			<div class="row" style="margin-bottom: -10px">
				<div class="col-xs-12 col-md-3 text-center form-group">
					<div style="margin-top: 17px">
						<span class="img-posicao" v-show="imgDataUrl != ''">
							<img
								:src="imgDataUrl"
								class="img-thumbnail"
								style="max-width: 150px; max-height: 150px"
							/>
						</span>

						<span class="img-posicao" v-show="imgDataUrl == ''">
							<img
								src="../../../../../../assets/img/sem_foto.png"
								class="img-rounded"
								style="max-width: 150px; max-height: 150px"
							/>
						</span>

						<div class="col-xs-12" style="margin-top: 8px">
							<a class="btn btn-info btn-xs no-print" @click="show = !show">
								<i class="fa fa-upload fa-fw" aria-hidden="true"></i
								>{{ _traducao('global', 'carregarFoto') }}
							</a>
							<a
								class="btn btn-danger no-print btn-xs"
								@click="clickExcluirFoto"
								v-show="imgDataUrl != ''"
							>
								<i class="fa fa-trash-o fa-fw" aria-hidden="true"></i
								>{{ _traducao('global', 'excluirFoto') }}
							</a>
						</div>

						<my-upload
							field="img"
							@crop-success="cropSuccess"
							:lang-type="_getLangCpUpload"
							v-model="show"
							:width="500"
							:height="500"
							:url="''"
							img-format="png"
						>
						</my-upload>
					</div>
				</div>

				<div class="col-xs-12 col-md-9">
					<div class="row">
						<div
							class="col-xs-12 col-md-6 form-group"
							:class="{
								'has-error': erro.nome != '',
								'col-md-6': existeTrigrama,
								'col-xs-12': _isMobile
							}"
						>
							<label
								><span class="no-print">* </span
								>{{ _traducao('menuAGnovoUsuario', 'menuAGnome') }}:</label
							>
							<input
								autocomplete="off"
								type="text"
								v-focus="form.nome"
								:disabled="habilitaEdicao"
								ref="date"
								v-model="form.nome"
								class="form-control input-sm"
							/>
							<p class="help-block" v-show="erro.nome != ''">{{ erro.nome }}</p>
						</div>

						<div
							class="col-xs-4 col-md-3 form-group"
							v-if="existeTrigrama"
							:class="{'has-error': erro.trigrama != ''}"
						>
							<label>
								<span class="no-print" v-if="_idCliente != 18">* </span
								>{{ _traducao('global', 'trigrama') }}:
							</label>
							<input
								v-if="_idCliente != 18"
								autocomplete="off"
								:disabled="habilitaEdicao"
								type="text"
								v-model="form.trigrama"
								@blur="validaTrigrama"
								@keyup="form.trigrama = form.trigrama.toUpperCase()"
								maxlength="3"
								minlength="3"
								@keydown="checkChar"
								class="form-control input-sm"
							/>
							<input
								v-if="_idCliente == 18"
								autocomplete="off"
								type="text"
								v-model="form.trigrama"
								@blur="validaTrigrama"
								@keyup="form.trigrama = form.trigrama.toUpperCase()"
								maxlength="3"
								@keydown="checkChar"
								minlength="3"
								class="form-control input-sm"
							/>
							<p class="help-block" v-show="erro.trigrama != ''">
								{{ erro.trigrama }}
							</p>
						</div>

						<!--  CODIGO ANAC -->
						<div class="col-xs-12 col-md-3 form-group">
							<label
								>{{ _traducao('menuUsuarioANAC', 'codigoAviacao') }}:</label
							>
							<input
								autocomplete="off"
								type="number"
								:disabled="_idCliente == 18 ? false : habilitaEdicao"
								v-model="form.codigo_anac"
								class="form-control input-sm"
							/>
						</div>
					</div>

					<div class="row" v-if="_idCliente != 41">
						<div
							class="col-xs-12 col-md-3 form-group"
							:class="{'has-error': erro.cpf !== ''}"
						>
							<label
								><span class="no-print" v-if="loginPor.cpf">* </span
								>{{ _traducao('menuAGnovoUsuario', 'menuAGcpf') }}:</label
							>
							<input
								autocomplete="off"
								v-model="form.cpf"
								:disabled="habilitaEdicao"
								@blur="verificarSeExisteCPF"
								class="form-control input-sm"
								v-mask="_vdocumento"
							/>
							<p class="help-block" v-show="erro.cpf != ''">{{ erro.cpf }}</p>
						</div>

						<div class="col-xs-12 col-md-3 form-group">
							<label>{{ _traducao('global', 'crea') }}:</label>
							<input
								autocomplete="off"
								v-model="form.crea"
								class="form-control input-sm"
								maxlength="15"
							/>
						</div>

						<div
							class="col-xs-12 col-md-3 form-group"
							:class="{'has-error': erro.celular != ''}"
						>
							<label
								><span class="no-print">* </span
								>{{ _traducao('menuAGnovoUsuario', 'menuAGcel1') }}:</label
							>
							<input
								autocomplete="off"
								v-model="form.celular"
								class="form-control input-sm"
								v-mask="_vcelular"
							/>
							<p class="help-block" v-show="erro.celular != ''">
								{{ erro.celular }}
							</p>
						</div>

						<div class="col-xs-12 col-md-3 form-group">
							<label>{{ _traducao('menuAGnovoUsuario', 'menuAGcel2') }}:</label>
							<input
								autocomplete="off"
								v-model="form.celular2"
								class="form-control input-sm"
								v-mask="_vcelular"
							/>
						</div>
					</div>

					<div class="row" v-if="_idCliente != 41">
						<div class="col-xs-12 col-md-4 form-group">
							<label
								><span class="no-print"></span
								>{{ _traducao('global', 'telefone') }}:</label
							>
							<input
								autocomplete="off"
								v-model="form.telefone"
								class="form-control input-sm"
								v-mask="_vtelefone"
							/>
						</div>

						<div
							class="col-xs-12 col-md-4 form-group print-ajuste-email"
							:class="{'has-error': erro.email != ''}"
						>
							<label>
								<span class="no-print" v-if="emailObrigatorio == '1'">* </span>
								{{ _traducao('menuAGnovoUsuario', 'menuAGemail') }}:
							</label>
							<input
								autocomplete="off"
								type="email"
								v-model="form.email"
								id="email"
								name="email"
								@blur="validaEmail()"
								class="form-control input-sm"
							/>
							<p class="help-block" v-show="erro.email != ''">
								{{ erro.email }}
							</p>
						</div>

						<div
							class="col-xs-12 col-md-4 form-group"
							:class="{'has-error': erro.id_orgao != ''}"
						>
							<label
								><span class="no-print">* </span>{{ centrodeOrgao }}:</label
							>
							<select
								v-model="form.id_orgao"
								class="form-control input-sm"
								autocomplete="off"
								autocorrect="off"
								autocapitalize="none"
								:disabled="habilitaEdicao"
							>
								<option value="">
									{{ _traducao('global', 'escolha').toUpperCase() }}
								</option>
								<option
									v-for="(item, idx) in orgaos"
									:value="item.id"
									:key="idx"
								>
									{{ item.descricao }}
								</option>
							</select>
							<p class="help-block" v-show="erro.id_orgao != ''">
								{{ erro.id_orgao }}
							</p>
						</div>
					</div>

					<div class="row" v-if="_idCliente == 41">
						<div
							class="col-xs-12 col-md-3 form-group"
							:class="{'has-error': erro.cpf !== ''}"
						>
							<label
								><span class="no-print" v-if="loginPor.cpf">* </span
								>{{ _traducao('menuAGnovoUsuario', 'menuAGcpf') }}:</label
							>
							<input
								autocomplete="off"
								v-model="form.cpf"
								:disabled="habilitaEdicao"
								@blur="verificarSeExisteCPF"
								class="form-control input-sm"
								v-mask="_vdocumento"
							/>
							<p class="help-block" v-show="erro.cpf != ''">{{ erro.cpf }}</p>
						</div>

						<div class="col-xs-12 col-md-3 form-group">
							<label>RG:</label>
							<input
								autocomplete="off"
								v-model="form.rg"
								class="form-control input-sm"
								maxlength="15"
							/>
						</div>

						<div class="col-xs-12 col-md-3 form-group">
							<label>CTPS:</label>
							<input
								autocomplete="off"
								v-model="form.ctps"
								class="form-control input-sm"
								maxlength="15"
							/>
						</div>

						<div class="col-xs-12 col-md-3 form-group">
							<label>{{ _traducao('global', 'crea') }}:</label>
							<input
								autocomplete="off"
								v-model="form.crea"
								class="form-control input-sm"
								maxlength="15"
							/>
						</div>
					</div>

					<div class="row" v-if="_idCliente == 41">
						<div class="col-xs-12 col-md-3 form-group">
							<label
								><span class="no-print"></span
								>{{ _traducao('global', 'telefone') }}:</label
							>
							<input
								autocomplete="off"
								v-model="form.telefone"
								class="form-control input-sm"
								v-mask="_vtelefone"
							/>
						</div>

						<div
							class="col-xs-12 col-md-3 form-group"
							:class="{'has-error': erro.celular != ''}"
						>
							<label
								><span class="no-print">* </span
								>{{ _traducao('menuAGnovoUsuario', 'menuAGcel1') }}:</label
							>
							<input
								autocomplete="off"
								v-model="form.celular"
								class="form-control input-sm"
								v-mask="_vcelular"
							/>
							<p class="help-block" v-show="erro.celular != ''">
								{{ erro.celular }}
							</p>
						</div>

						<div class="col-xs-12 col-md-3 form-group">
							<label>{{ _traducao('menuAGnovoUsuario', 'menuAGcel2') }}:</label>
							<input
								autocomplete="off"
								v-model="form.celular2"
								class="form-control input-sm"
								v-mask="_vcelular"
							/>
						</div>

						<div class="col-xs-12 col-md-3 form-group">
							<label>{{ _traducao('global', 'escolaridade') }}:</label>
							<select
								v-model="form.escolaridade"
								class="form-control input-sm"
								autocomplete="off"
								autocorrect="off"
								autocapitalize="none"
								:disabled="habilitaEdicao"
							>
								<option value="">
									{{ _traducao('global', 'escolha').toUpperCase() }}
								</option>
								<option value="Educação infantil">
									{{ _traducao('global', 'ensinoInfantil') }}
								</option>
								<option value="Ensino Fundamental">
									{{ _traducao('menuAGcadAluno', 'ensinoFundamental') }}
								</option>
								<option value="Ensino Médio">
									{{ _traducao('menuAGcadAluno', 'ensinoMedio') }}
								</option>
								<option value="Ensino Superior (Graduação)">
									{{ _traducao('global', 'ensinoSuperior') }}
								</option>
								<option value="Pós-graduação">Pós-graduação</option>
								<option value="Mestrado">
									{{ _traducao('menuAGcadAluno', 'mestrado') }}
								</option>
								<option value="Doutorado">
									{{ _traducao('menuAGcadAluno', 'doutorado') }}
								</option>
							</select>
						</div>
					</div>

					<div class="row" v-if="_idCliente == 41">
						<div
							class="col-xs-12 col-md-6 form-group print-ajuste-email"
							:class="{'has-error': erro.email != ''}"
						>
							<label>
								<span class="no-print" v-if="emailObrigatorio == '1'">* </span>
								{{ _traducao('menuAGnovoUsuario', 'menuAGemail') }}:
							</label>
							<input
								autocomplete="off"
								type="email"
								v-model="form.email"
								id="email"
								name="email"
								@blur="validaEmail()"
								class="form-control input-sm"
							/>
							<p class="help-block" v-show="erro.email != ''">
								{{ erro.email }}
							</p>
						</div>
						<div class="col-xs-12 col-md-3 form-group">
							<label>{{ _traducao('global', 'sexo') }}:</label>
							<select
								v-model="form.sexo"
								class="form-control input-sm"
								autocomplete="off"
								autocorrect="off"
								autocapitalize="none"
								:disabled="habilitaEdicao"
							>
								<option value="">
									{{ _traducao('global', 'escolha').toUpperCase() }}
								</option>
								<option value="Feminino">
									{{ _traducao('global', 'fem') }}
								</option>
								<option value="Masculino">
									{{ _traducao('global', 'masc') }}
								</option>
								<option value="Prefiro não declarar">
									{{ _traducao('global', 'prefiroNaoDeclarar') }}
								</option>
							</select>
						</div>

						<div class="col-xs-12 col-md-3 form-group">
							<label
								><span class="no-print"></span
								>{{ _traducao('global', 'dataNascimento') }}:</label
							>
							<flDateTime
								@v-model="(val) => (form.data_nascimento = val)"
								:value="form.data_nascimento"
								:lang="_getLangDp"
								:format="_formatDate"
								name="data_nascimento"
							/>
						</div>
					</div>

					<div class="row" v-if="_idCliente == 41">
						<div class="col-xs-12 col-md-6 form-group">
							<label>{{ _traducao('menuAGcadAluno', 'nomePai') }}:</label>
							<input
								autocomplete="off"
								type="text"
								v-model="form.nome_pai"
								class="form-control input-sm"
							/>
						</div>
						<div class="col-xs-12 col-md-6 form-group">
							<label>{{ _traducao('menuAGcadAluno', 'nomeMae') }}:</label>
							<input
								autocomplete="off"
								type="text"
								v-model="form.nome_mae"
								class="form-control input-sm"
							/>
						</div>
					</div>

					<div class="row" v-if="_idCliente == 41">
						<div class="col-xs-12 col-md-3 form-group">
							<label>{{ _traducao('global', 'nacionalidade') }}:</label>
							<input
								autocomplete="off"
								type="text"
								v-model="form.nacionalidade"
								class="form-control input-sm"
							/>
						</div>
						<div class="col-xs-12 col-md-3 form-group">
							<label>{{ _traducao('global', 'naturalidade') }}:</label>
							<input
								autocomplete="off"
								type="text"
								v-model="form.naturalidade"
								class="form-control input-sm"
							/>
						</div>
						<div class="col-xs-12 col-md-3 form-group">
							<label>{{ _traducao('global', 'estadoCivil') }}:</label>
							<input
								autocomplete="off"
								type="text"
								v-model="form.estado_civil"
								class="form-control input-sm"
							/>
						</div>
						<div
							class="col-xs-12 col-md-3 form-group"
							:class="{'has-error': erro.peso != ''}"
						>
							<label
								><span class="no-print">* </span
								>{{ _traducao('global', 'pesoAprox') }}:</label
							>
							<money
								v-model="form.peso"
								v-bind="_vpercem(2, null, ' KG')"
								class="form-control input-sm"
							></money>
							<p class="help-block" v-show="erro.peso != ''">
								{{ erro.peso }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import myUpload from 'vue-image-crop-upload'
import tiposLoginUsuarioMixin from '../mixins/tiposLoginUsuario.mixin'
export default {
	props: {
		orgaos: {
			type: Array
		},
		menu: {
			type: Boolean
		},
		existeTrigrama: {
			type: Boolean
		},
		token: {
			type: String,
			require: false
		}
	},

	components: {
		myUpload
		// flAcessoSistema
	},
	mixins: [tiposLoginUsuarioMixin],
	data() {
		return {
			emailObrigatorio: window.$cliente.get('email_obrigatorio_usuario'),
			show: false,
			imgDataUrl: '',
			id_base: [],
			tipo: '',
			urlEnvio: this.getURL_WS('/Utilitarios/recebe_arquivo'),
			centrodeOrgao: '',

			form: {
				id: 0,
				nome: '',
				cpf: '',
				email: '',
				id_orgao: '',
				codigo_anac: '',
				foto: '',
				foto_antiga: '',
				telefone: '',
				celular: '',
				celular2: '',
				crea: '',
				id_usuario: window.$sessao.getId(),
				trigrama: '',
				novo_usuario: '',
				data_nascimento: '',
				rg: '',
				sexo: '',
				ctps: '',
				nome_pai: '',
				nome_mae: '',
				nacionalidade: '',
				naturalidade: '',
				estado_civil: '',
				nome_tratamento: '',
				escolaridade: '',
				tipo_guarnicao: '',
				peso: '',
				id_base: ''
			},

			erro: {
				wsCPF: false,
				wsEmail: false,
				wsTrigrama: false,
				trigrama: '',
				nome: '',
				cpf: '',
				email: '',
				id_orgao: '',
				celular: '',
				peso: '',
				id_base: ''
			}
		}
	},

	computed: {
		loginIAM() {
			return window.$cliente.get('login_iam') == '1'
		},

		habilitaEdicao() {
			let passou = false

			if (this.loginIAM && this.form.novo_usuario == '1') {
				passou = false
			} else if (
				this.menu ||
				(this.form.id != 0 && !this._getPrivilegio(149))
			) {
				passou = true
			}
			return passou
		}
	},

	created() {
		this.getBase()
		this.parametros()
	},

	methods: {
		parametros() {
			this._getParametro(59).then((valor) => (this.centrodeOrgao = valor))
		},

		editar(item) {
			this.form.id = item.id
			this.form.novo_usuario = item.novo_usuario
			this.form.nome = item.nome
			this.form.cpf = item.cpf
			this.form.email = item.email
			this.form.id_orgao = item.id_orgao
			this.form.codigo_anac = item.codigo_anac
			this.form.foto = item.foto
			this.form.foto_antiga = item.foto_antiga
			this.form.telefone = item.telefone
			this.form.celular = item.celular
			this.form.celular2 = item.celular2
			this.form.crea = item.crea
			this.form.trigrama = item.trigrama
			this.form.interno = item.interno
			this.form.data_nascimento = item.data_nascimento
			this.form.rg = item.rg
			this.form.sexo = item.sexo
			this.form.ctps = item.ctps
			this.form.nome_pai = item.nome_pai
			this.form.nome_mae = item.nome_mae
			this.form.nacionalidade = item.nacionalidade
			this.form.naturalidade = item.naturalidade
			this.form.estado_civil = item.estado_civil
			this.form.nome_tratamento = item.nome_tratamento
			this.form.escolaridade = item.escolaridade
			this.form.tipo_guarnicao = item.tipo_guarnicao
			this.form.peso = item.peso
			this.tipo = item.tipo
			this.form.id_base = item.id_base

			if (item.foto != '') {
				this.form.foto = item.foto
				this.form.foto_antiga = this.form.foto
				this.imgDataUrl =
					this.getURL_WS('foto/').replace('public/', '') + this.form.foto
			} else {
				this.imgDataUrl = ''
				this.form.foto = ''
			}

			this.$forceUpdate()
		},

		getBase() {
			this._axios('Base/get', 'get', {
				callback: (retorno) => {
					if (retorno._request) {
						var list = []

						retorno.lista = retorno.lista.map((item, p) => {
							item._index = p
							item._exibir = false
							return item
						})

						this.id_base = retorno.lista
					}
				}
			})
		},

		cropSuccess(imgDataUrl, field) {
			//this.imgDataUrl = imgDataUrl;
			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carrgandoFoto')
			})
			this._enviarImagem(
				(retorno) => {
					window.bus.$emit('load-out')

					if (retorno) {
						if (retorno.status == 'sucesso') {
							this.form.foto = retorno.url_img
							this.imgDataUrl =
								this.getURL_WS('tmp/').replace('public/', '') + this.form.foto
						} else {
							window.bus.$emit('exibir-notificacao', {
								type: 'danger',
								text: retorno.mensagem
							})
						}
					}
				},
				imgDataUrl,
				this.token
			)
		},

		validaTrigrama() {
			this.validaTrigramaServidor(
				(retorno) => {
					if (!retorno) {
						this.erro.trigrama = this._traducao('global', 'jaExiste')
						this.erro.wsTrigrama = true
					} else {
						this.erro.trigrama = ''
						this.erro.wsTrigrama = false
					}
				},
				this.form.trigrama,
				this.form.id == 0 ? null : this.form.id
			)
		},

		get() {
			this._axios('Base/get', 'get', {
				callback: (retorno) => {
					if (retorno._request) {
						var list = []

						retorno.lista = retorno.lista.map((item, p) => {
							item._index = p
							item._exibir = false
							return item
						})

						this.id_base = retorno.lista
					}
				}
			})
		},

		validaTrigramaServidor(callback, trigrama, id_usuario) {
			var data = {
				trigrama: trigrama,
				id_usuario: id_usuario
			}

			this._httpPost(
				'/Usuario/verifica_trigrama',
				data,
				(retorno) => {
					if (retorno._request) {
						if (retorno._status) {
							callback(true)
						} else {
							callback(false)
						}
					} else {
						callback(false)
					}
				},
				this.token
			)
		},

		clickExcluirFoto() {
			this.foto_antiga = this.form.foto
			this.form.foto = ''
			this.imgDataUrl = ''
		},

		validaEmail() {
			if (this.form.email != '' && !this._isEmail(this.form.email)) {
				this.erro.email = this._traducao('global', 'emailInvalido')
				this.erro.wsEmail = true
			} else {
				this.erro.email = ''
				if (this.form.email != '') {
					this.validaEmailServidor(
						(retorno) => {
							if (!retorno) {
								this.erro.email = this._traducao('global', 'emailJaCadastrado')
								this.erro.wsEmail = true
							} else {
								this.erro.email = ''
								this.erro.wsEmail = false
							}
						},
						this.form.email,
						this.form.id == 0 ? null : this.form.id
					)
				}
			}
		},

		validaEmailServidor(callback, email, id_usuario) {
			var data = {
				email: email,
				id_usuario: id_usuario
			}

			// valida o email
			this._httpPost(
				'/Usuario/verifica_email',
				data,
				(retorno) => {
					if (retorno._request && retorno._status) {
						callback(true)
					} else {
						callback(false)
					}
				},
				this.token
			)
		},

		verificarSeExisteCPF() {
			if (this.form.cpf.trim() != '') {
				this._httpGet(
					'/Usuario/verifica_cpf/' + this.form.cpf + '/' + this.form.id,
					(retorno) => {
						if (retorno._request && retorno._status) {
							this.erro.cpf = ''
							this.erro.wsCPF = false

							if (this.form.id === 0) {
								this.$emit(
									'setar-login-senha',
									this.form.cpf
										.replace('.', '')
										.replace('.', '')
										.replace('-', '')
								)
							}
						} else if (!retorno._status) {
							this.erro.cpf = this._traducao(
								'global',
								'cpfInvalidoOuJaCadastradoNoSistema'
							)
							this.erro.wsCPF = true
						}
					},
					this.token
				)
			}
		},

		validaForm() {
			var passou = true
			var obrigatorio = this._traducao('global', 'campoObrigatorio')

			if (this.form.nome.trim() == '') {
				this.erro.nome = obrigatorio
				passou = false
			} else {
				this.erro.nome = ''
			}

			if (this.existeTrigrama && this._idCliente != 18) {
				if (this.form.trigrama.length != 3) {
					this.erro.trigrama = 'Três letras.'
					passou = false
				} else {
					if (this.erro.wsTrigrama) {
						passou = false
					} else {
						this.erro.trigrama = ''
					}
				}
			}

			if (this.form.cpf.trim() === '' && this.loginPor.cpf) {
				this.erro.cpf = obrigatorio
				passou = false
			} else {
				if (this.erro.wsCPF) {
					passou = false
				} else {
					this.erro.cpf = ''
				}
			}

			if (this.form.email.trim() === '' && this.emailObrigatorio == '1') {
				this.erro.email = obrigatorio
				passou = false
			} else {
				if (this.erro.wsEmail) {
					passou = false
				} else {
					this.erro.email = ''
				}
			}

			if (this.form.celular.trim() == '') {
				this.erro.celular = obrigatorio
				passou = false
			} else {
				this.erro.celular = ''
			}

			if (this._idCliente != 41) {
				if (this.form.id_orgao == '') {
					this.erro.id_orgao = obrigatorio
					passou = false
				} else {
					this.erro.id_orgao = ''
				}
			} else {
				if (Number(this.form.peso) <= 0) {
					this.erro.peso = obrigatorio
					passou = false
				} else {
					this.erro.peso = ''
				}
			}

			if (passou) {
				this.$emit('form-cadastro', this.form)
			}

			return passou
		},
		checkChar(char) {
			var pattern = '[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]'
			if (char.key.match(pattern)) {
				return true
			} else {
				return char.preventDefault()
			}
		}
	}
}
</script>
<style scoped></style>